import ProcedureMethodNodeAdapter from 'procedures/processes/ProcedureMethodNodeAdapter';
import {ProcessFlowchartNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {FlowchartValidator} from 'processes/graph-builder-processes/platform/FlowchartValidator';
import {
  ProcessesPluginBase,
  ProcessesPluginMetadataEditorItem,
} from 'processes/graph-builder-processes/platform/ProcessesPluginBase';

import ProcedureFlowchartValidator from './ProcedureFlowchartValidator';
import ProcedureRootNodeAdapter from './ProcedureRootNodeAdapter';

export class ProcedureProcessesPlugin extends ProcessesPluginBase {
  static readonly FLOWCHART_TYPE_NAME = 'PROCEDURE_FLOWCHART';

  readonly pluginName: string = 'Procedures Plugin';
  readonly flowchartTypeName: string = ProcedureProcessesPlugin.FLOWCHART_TYPE_NAME;

  readonly nodeAdapters: Array<ProcessFlowchartNodeAdapter> = [
    new ProcedureMethodNodeAdapter(),
    new ProcedureRootNodeAdapter(),
  ];

  readonly flowchartValidator: FlowchartValidator = new ProcedureFlowchartValidator();
  readonly metadataEditor?: ProcessesPluginMetadataEditorItem = undefined;
}
